export enum AssetsCategories {
  all = 'All',
  product = 'Products',
  logo = 'Logo',
  badge = 'Badge',
  bgMobile = 'Mobile Background',
  bgDesk = 'Desktop Background',
  bgBundle = 'Bundle Background',
  bgPopup = 'Popup Background',
  favicon = 'Favicon',
  productPrefix = 'Product Prefix',
  general = 'General',
  banner = 'Banner',
  offerHeader = 'Offer Header',
  playerLevel = 'Player Level',
  section = 'Section',
  addToHomeButtonImage = 'Button Image',
  addToHomeIconImage = 'Icon Image',
  playerProfileImage = 'Player profile Image',
  backToGameButtonImage = 'Back To Game Button',
  animation = 'Animation',
  trait = 'Trait'
}
